import { SERVICES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const servicesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getServices: build.query({
      query: (params = {}) => ({ url: SERVICES.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Service', result),
    }),
    getServiceById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return { url: SERVICES.BY_ID(id), method: 'GET', params };
      },
      providesTags: (_r, _e, arg) => [
        {
          type: 'Service',
          id: typeof arg === 'object' && arg != null ? arg.id : arg,
        },
      ],
    }),
    createService: build.mutation({
      query: (payload) => {
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: SERVICES.LIST,
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'Service', id: 'LIST' }],
    }),
    updateService: build.mutation({
      query: ({ id, data: updateData, params, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: SERVICES.BY_ID(id),
          method: 'PUT',
          data: payload,
          params,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Service', id },
        { type: 'Service', id: 'LIST' },
      ],
    }),
    deleteService: build.mutation({
      query: (id) => ({ url: SERVICES.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'Service', id },
        { type: 'Service', id: 'LIST' },
      ],
    }),
    approveService: build.mutation({
      query: ({ id, data: payload }) => {
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: SERVICES.APPROVE(id),
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Service', id },
        { type: 'Service', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetServicesQuery,
  useLazyGetServicesQuery,
  useGetServiceByIdQuery,
  useLazyGetServiceByIdQuery,
  useCreateServiceMutation,
  useUpdateServiceMutation,
  useDeleteServiceMutation,
  useApproveServiceMutation,
} = servicesApi;
